import React from 'react'
import './CTAbutton.css'
import { Link } from "react-router-dom";

export const CTAbutton = ({btn, addressId}) => {
  return (
    <Link to={`article/${addressId}`} className='wordpay-demo__cta-button'>
     {btn}
    </Link>
  )
}
